<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    :size="data.size || 'md'"
    :centered="data.centered || false"
    :scrollable="data.scrollable || false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    :title-html="_trans('Edit Wall')"
    :ok-only="true"
    :ok-title="_trans('Ok')"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
    @ok="updateAndConfirm()"
  >
    <template v-slot:modal-header-close>
      <b-button size="sm" variant="primary" class="ni ni-close"
                @click="close()"
      >
      </b-button>
    </template>
    <b-row :no-gutters="true">
      <b-col class="px-1">
        <label>
          <input-length-measure
            ref="lengthInput"
            v-model="length"
            :unit="lengthUnit"
            @keyup.enter="updateAndConfirm()"
            @blur="checkValue('length', $event)"
          >
            <template v-slot:prepend>
              <div class="input-group-prepend">
                <span class="input-group-text" v-text="_trans('Length')"></span>
              </div>
            </template>
          </input-length-measure>
        </label>
      </b-col>
      <b-col class="px-1">
        <label>
          <input-length-measure
            v-model="depth"
            :unit="lengthUnit"
            @keyup.enter="updateAndConfirm()"
            @blur="checkValue('depth', $event)"
          >
            <template v-slot:prepend>
              <div class="input-group-prepend">
                <span class="input-group-text" v-text="_trans('Depth')"></span>
              </div>
            </template>
          </input-length-measure>
        </label>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import modal from '@dialogs/modal'

export default {
    mixins: [modal],
    components: {
        inputLengthMeasure: () => import('@configurator/comp/inputLengthMeasure.vue')
    },
    data() {
        return {
            depth: 0,
            length: 0
        }
    },
    computed: {
         wallData() {
            return this.data
        }
    },
    methods: {
        checkValue(type, evt) {
            if(type === 'length') {
                this.length = isNaN(this.length) ? 0 : this.length
            }
            if(type === 'depth')
                this.depth = isNaN(this.depth) ? 0 : this.depth
        },
        /** Close modal dialog after save and/or update customer
         *
         */
        updateAndConfirm() {
            this.depth = isNaN(this.depth) ? 0 : this.depth
            this.length = isNaN(this.length) ? 0 : this.length

            // Check limits for walls
            if(this.depth < 10){
                this.depth = 10
            }
            if(this.depth > 2000) {
                this.depth = 2000
            }

            if(this.length < 10){
                this.length = 10
            }
            if(this.length > 50000) {
                this.length = 50000
            }

            let data = {
                length: this.length,
                depth: this.depth
            }
            this.$store.commit('cad/setWallCreationData', data)
            this.close(1)
        },
        onShow() {
            this.length = this.data.wallData.length
            this.depth = this.data.wallData.depth
            this.$refs.lengthInput.focus()
        }
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/app/dialogs/modalEditWall.vue